import { Validators } from '@angular/forms';
import { Attachment } from 'go-modules/services/attachment/attachment';
import type { LlmDefinition } from '@go-modules/interfaces/llm-definition';
import { Media } from 'go-modules/services/attachment/media';

/**
 * Configuration for activity form fields
 * This makes it easy to add/remove fields and their validation rules
 */
export interface ActivityFormFieldConfig {
	[key: string]: {
		defaultValue: any;
		validators?: any[];
		type?: 'string' | 'boolean' | 'number' | 'array' | 'object';
	};
}

export const ACTIVITY_FORM_CONFIG: ActivityFormFieldConfig = {
	name: {
		defaultValue: '',
		validators: [Validators.required, Validators.maxLength(255)],
		type: 'string'
	},
	is_video_share_enabled: {
		defaultValue: false,
		type: 'boolean'
	},
	available_at: {
		defaultValue: null,
		type: 'object'
	},
	due_at: {
		defaultValue: null,
		type: 'object'
	},
	total_score: {
		defaultValue: null,
		type: 'number'
	},
	rubric_template_id: {
		defaultValue: null,
		type: 'number'
	},
	can_reviewers_see_grades: {
		defaultValue: false,
		type: 'boolean'
	},
	attachments: {
		defaultValue: [],
		type: 'array'
	},
	activity_template_id: {
		defaultValue: null,
		type: 'number'
	},
	has_self_select_source_media: {
		defaultValue: false,
		type: 'boolean'
	},
	source_media: {
		defaultValue: null,
		type: 'object'
	},
	source_type: {
		defaultValue: null,
		type: 'string'
	},
	live_session_enabled: {
		defaultValue: false,
		type: 'boolean'
	},
	show_tasks: {
		defaultValue: false,
		type: 'boolean'
	},
	tag_set_id: {
		defaultValue: null,
		type: 'number'
	},
	ai_prompts_enabled: {
		defaultValue: false,
		type: 'boolean'
	},
	ai_transcription_language: {
		defaultValue: null,
		type: 'string'
	},
	llm_definitions: {
		defaultValue: [],
		type: 'array'
	}
};

export interface ActivityFormValue {
	name: string;
	is_video_share_enabled: boolean;
	available_at: Date | null;
	due_at: Date | null;
	total_score: number|null;
	rubric_template_id: number|null;
	can_reviewers_see_grades: boolean;
	attachments: Attachment[];
	activity_template_id: number|null;
	has_self_select_source_media: boolean;
	source_media: Media | null;
	source_type: string|null;
	live_session_enabled: boolean;
	show_tasks: boolean;
	tag_set_id: number|null;
	ai_prompts_enabled: boolean;
	ai_transcription_language: string|null;
	llm_definitions: LlmDefinition[];
}
